// extracted by mini-css-extract-plugin
module.exports = {"inputCustom":"AdditionallyBody_inputCustom__3K1ND"};